import React from "react";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutlined";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import { useTheme } from "@mui/material";

type Props = {
  onClick: any;
  disabled: boolean;
  loading: boolean;
};

export const RemoveButton = ({ onClick, disabled, loading }: Props) => {
  const theme = useTheme();

  return (
    <IconButton onClick={onClick} disabled={disabled} edge="end" size="large">
      {loading ? (
        <CircularProgress size={16} />
      ) : (
        <RemoveCircleOutlineIcon
          style={{ color: disabled ? `${theme.palette.greyDesign.onSurface3}` : `${theme.palette.greyDesign.surface2}`, verticalAlign: "middle" }}
        />
      )}
    </IconButton>
  );
};
